export const GATEWAY_RETRY_DELAY_MS = 2500;
export const MAX_GATEWAY_RETRIES = 1;

export const RETRYABLE_GATEWAY_METHODS: ReadonlySet<string> = new Set([
  "get",
  "head",
]);

export const RETRYABLE_GATEWAY_STATUSES: ReadonlySet<number> = new Set([
  502,
  504,
]);

export const isRetryableGatewayStatus = (status: unknown): boolean =>
  RETRYABLE_GATEWAY_STATUSES.has(Number(status));

export const shouldRetryGatewayRequest = (
  method: string | undefined,
  status: unknown,
  retryCount: number,
): boolean =>
  retryCount < MAX_GATEWAY_RETRIES &&
  RETRYABLE_GATEWAY_METHODS.has(method?.toLowerCase() ?? "") &&
  isRetryableGatewayStatus(status);

export const waitForGatewayRetry = (): Promise<void> =>
  new Promise((resolve) => setTimeout(resolve, GATEWAY_RETRY_DELAY_MS));
